import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { loginRequest, GetAccessToken, SetAccessToken } from "../authConfig";
import { DriveItemComponent, DriveItemComponentParent } from "./DriveItemComponent";
import { fetchUserMe, fetchDirectory, FolderData, FolderDataFileEntry } from "../graph";
import { User, DriveItem} from "@microsoft/microsoft-graph-types";
import { Hash } from "crypto";

export type ViewMode = 'small'|'medium'|'large'|'table';

export function DirectoryList( props: {pathName:string|null, viewMode:ViewMode} ) : JSX.Element {
  const { instance, accounts } = useMsal();
  const [folderData, setFolderData] = useState<FolderData>({items:[], extraInfo:null});

  const pathName = (props.pathName && props.pathName !== '') ? props.pathName : '/';

  useEffect(() => {
    const authRequestParams = {
      ...loginRequest,
      account: accounts[0],
    };
    instance.acquireTokenSilent(authRequestParams).then(async (response) => {
      SetAccessToken(response.accessToken);

      const directory = await fetchDirectory('', pathName);
      setFolderData(directory);

    });
  }, [props.pathName]);


  var folderDataByFilename = new Map<string, FolderDataFileEntry>(
    folderData.extraInfo != null ?
      folderData.extraInfo.Descriptions.map( d => [d.Filename.toLowerCase(), d]) :
      []
  );

  var directoryItems = folderData.items.map( (entry) => {
      var extraInfo : FolderDataFileEntry|null|undefined = null;
      if( entry.name != null ) {
        extraInfo = folderDataByFilename.get(entry.name.toLowerCase());
        //Not sure what this is about.
        if(extraInfo === undefined)
          extraInfo = null;
      } 
      return <DriveItemComponent viewMode={props.viewMode} item={entry} extraInfo={extraInfo} key={entry.id} parentLocation={pathName} />
    });

  if( pathName !== '/') {
    directoryItems.unshift(<DriveItemComponentParent key='..' parentLocation={pathName} />)
  }

  const name = accounts[0] && accounts[0].name;

  return (
    <>
      {directoryItems}
    </>
  );
}

